import { type ReactNode, useState } from 'react';
import { Modal } from '@/components/ui/modal';
import { useSwapIg } from '@/hooks/use-ig-mutations';
import type { Approacher } from '../types';
import { SwapPreview } from './swap-ig-preview';
import { SwapIgActions } from './swap-ig-actions';

type Props = {
  open: boolean;
  onClose: () => void;
  approacher: Approacher;
  onUpdated?: (() => void) | undefined;
};

const WARN = [
  'Se intercambiará el Instagram principal con el personal.',
  'El ManyChat ID se borrará: el bot se re-vinculará la próxima vez',
  'que el miembro envíe un lead. El cambio es reversible volviendo',
  'a hacer un swap.',
].join(' ');

function useSwapAction(p: Props) {
  const swap = useSwapIg();
  const [error, setError] = useState('');
  const onConfirm = (): void => {
    setError('');
    swap.mutate(
      { id: p.approacher.id, mode: 'swap' },
      {
        onSuccess: () => {
          p.onUpdated?.();
          p.onClose();
        },
        onError: (err) =>
          setError(err instanceof Error ? err.message : 'Error'),
      }
    );
  };
  return { onConfirm, error, pending: swap.isPending };
}

export function SwapIgModal(p: Props): ReactNode {
  const { onConfirm, error, pending } = useSwapAction(p);
  const canSwap = !!p.approacher.personal_ig_username;
  return (
    <Modal
      open={p.open}
      onClose={p.onClose}
      title="Intercambiar Instagram"
      size="md"
    >
      <SwapPreview
        currentPrimary={p.approacher.ig_username}
        currentSecondary={p.approacher.personal_ig_username || ''}
      />
      <p className="mt-md text-xs leading-relaxed text-text-tertiary">{WARN}</p>
      {error && <p className="mt-sm text-xs text-error">{error}</p>}
      <SwapIgActions
        canSwap={canSwap}
        pending={pending}
        onCancel={p.onClose}
        onConfirm={onConfirm}
      />
    </Modal>
  );
}
